import React from 'react';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function TeamShortTermGoalDisplay() 
{
    const { short_term_goal } = useCTAL();

    if (!short_term_goal) return;
   
    if (DEBUG) console.log(`TeamShortTermGoalsDisplay* - Goal: ${short_term_goal.Goal} Desc: ${short_term_goal.STGDescription}`)

    return (
        <>
            <div class="mb-0 py-0">
                <b>{short_term_goal.Goal}</b>
            </div> 
            <small><i>{short_term_goal.STGDescription}</i></small> 
        </>
    );
}